import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from './AppIcon';
import Button from './ui/Button';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location?.pathname]);

  const navigationItems = [
  { label: 'Home', path: '/homepage', icon: 'Home' },
  { label: 'Menu', path: '/menu', icon: 'UtensilsCrossed' },
  { label: 'About', path: '/about', icon: 'Info' },
  { label: 'Gallery', path: '/gallery', icon: 'Images' },
  { label: 'Contact', path: '/contact', icon: 'Phone' }];


  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleWhatsAppOrder = () => {
    window.open('https://wa.me/211915497014?text=Hello%20Chapati%20Plus!%20I%20would%20like%20to%20place%20an%20order.', '_blank');
  };

  const isActivePath = (path) => {
    return location?.pathname === path;
  };

  return (
    <>
      <header className={`header-container ${isScrolled ? 'shadow-warm' : ''}`}>
        <div className="header-content">
          <div className="header-logo" onClick={() => handleNavigation('/homepage')} style={{ cursor: 'pointer' }}>
            <div className="header-logo-icon">
              <img src="/assets/images/logo-1767562373802.jpeg" alt="Chapati Plus Logo" className="w-full h-full object-contain rounded-lg" />
            </div>
            <span></span>
          </div>

          <nav className="header-nav">
            {navigationItems?.map((item) =>
            <button
              key={item?.path}
              onClick={() => handleNavigation(item?.path)}
              className={`header-nav-link ${isActivePath(item?.path) ? 'active' : ''}`}>

                {item?.label}
              </button>
            )}
          </nav>

          <div className="header-cta">
            <Button
              variant="outline"
              size="default"
              iconName="Phone"
              iconPosition="left"
              onClick={() => window.open('tel:+211915497014', '_self')}>

              Call Us
            </Button>
            <Button
              variant="default"
              size="default"
              iconName="MessageCircle"
              iconPosition="left"
              onClick={handleWhatsAppOrder}
              className="whatsapp-button bg-accent hover:bg-accent/90">

              Order on WhatsApp
            </Button>
          </div>

          <button
            className="header-mobile-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle mobile menu">

            <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={24} color="var(--color-foreground)" />
          </button>
        </div>
      </header>
      <div className={`mobile-menu-overlay ${!isMobileMenuOpen ? 'closed' : ''}`}>
        <div className="mobile-menu-content">
          <nav className="mobile-menu-nav">
            {navigationItems?.map((item) =>
            <button
              key={item?.path}
              onClick={() => handleNavigation(item?.path)}
              className={`mobile-menu-link ${isActivePath(item?.path) ? 'active' : ''}`}>

                <div className="flex items-center gap-3">
                  <Icon name={item?.icon} size={20} />
                  <span>{item?.label}</span>
                </div>
              </button>
            )}
          </nav>

          <div className="mobile-menu-cta">
            <Button
              variant="outline"
              size="lg"
              iconName="Phone"
              iconPosition="left"
              fullWidth
              onClick={() => window.open('tel:+211915497014', '_self')}>

              Call Us Now
            </Button>
            <Button
              variant="default"
              size="lg"
              iconName="MessageCircle"
              iconPosition="left"
              fullWidth
              onClick={handleWhatsAppOrder}
              className="whatsapp-button bg-accent hover:bg-accent/90">

              Order on WhatsApp
            </Button>
          </div>
        </div>
      </div>
    </>);

};

export default Header;